import { Label } from '../../labels';

export interface RoutineConfig {
  title: string;
  routineButtonText?: string;
  issuePrefix?: string;
  reportOnException?: boolean;
  inventory?: boolean;
  uom?: string;
  autoLabels?: Label[];
}

export interface SingleStateConfig extends RoutineConfig {
  instructions: string;
}
